import React, { useEffect } from "react";
import { useDashboardStats } from "../../hooks/useDashboardStats";
import Subscription from "./Subscription";
import Overview from "./Overview";
import RecentTransactions from "./RecentTransactions";
import TopSellingProducts from "./TopSellingProducts";
import { InvoiceCard } from "./InvoiceCard";
import { Invoiceicon } from "../../assets/icons";
import { ExpenseCategories } from "./ExpenseCategories";
import { InvoiceStatus } from "./InvoicesStatus";
import CashflowTrend from "./CashflowTrend";
import { useTranslation } from "react-i18next";
import MostBookedServices from "./MostBookedServices";
import { useFetchTransactions } from "../../hooks/useFetchTransactions";
import ToDos from "./ToDos";
import CalenderDatePicker from "../CalenderDatePicker";
import ProductAndServicesLoader from "./Loading/ProductAndServicesLoader";
import StockAlert from "./StockAlert";
import ExpenseModal from "./ExpenseModal";

const Dashboard = () => {
  const { t } = useTranslation("dashboard");
  const {
    selected,
    selectedLabel,
    isLoadingDashBoardStat,
    dashBoardStatError,
    dashboardStats,
    showCalendar,
    setShowCalendar,
    handleRangeSelect,
    handleApplyButtonClick,
    calendarRef,
    businessType,
    fetchDashboardStats,
    startDate,
    endDate,
    setSelectedLabel,
  } = useDashboardStats();
  const [expandExpense, setExpandExpense] = React.useState(false);

  const { transactions, error, isLoading } = useFetchTransactions();

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      //@ts-ignore
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCalendarToggle = () => {
    setShowCalendar(!showCalendar);
  };
  const handleExpandToggle = () => {
    setExpandExpense(!expandExpense);
  };

  if (dashBoardStatError) {
    return <div>{dashBoardStatError}</div>;
  }
  let isFilter = selectedLabel != "Last 90 Days";

  return (
    <div>
      <>
        <div className="mb-[5em] relative">
          <Subscription />
          <Overview
            selectedLabel={selectedLabel}
            showCalendar={showCalendar}
            dashboardStats={dashboardStats}
            handleCalendarToggle={handleCalendarToggle}
            startDate={startDate}
            endDate={endDate}
            setSelectedLabel={setSelectedLabel}
            onRangeSelect={handleRangeSelect}
            selected={selected}
            onApplyButtonClick={(startDate, endDate) =>
              handleApplyButtonClick(startDate, endDate)
            }
            isLoading={isLoadingDashBoardStat}
            handleExpandToggle={handleExpandToggle}
            businessType={businessType}
          />

          <div className="flex flex-col items-stretch lg:flex-row gap-4 mt-4 h-full">
            <InvoiceCard
              icon={<Invoiceicon />}
              title={t("transactionInvoices")}
              toolTipText={t("InvoicesTooltip")}
              value={selectedLabel}
              text={t("totalInvoices")}
              totalNumber={dashboardStats?.invoices?.totalInvoices}
              refundNumber={dashboardStats?.invoiceStatuses?.refunded.amount}
              data={dashboardStats?.invoices}
              startDate={startDate}
              endDate={endDate}
              isLoading={isLoadingDashBoardStat}
              isFilter={isFilter}
            />

            {businessType == "service" ? (
              <MostBookedServices />
            ) : (
              <StockAlert businessType={businessType} />
            )}
          </div>
          <CashflowTrend />
        </div>

        <div
          className={`relative flex justify-center ${
            showCalendar ? "cursor-pointer" : ""
          } `}
          ref={calendarRef}
        >
          {showCalendar && (
            <>
              <div className="fixed inset-0  bg-gray-800 bg-opacity-80 z-40">
                <div className="flex justify-center ">
                  <CalenderDatePicker
                    onRangeSelect={handleRangeSelect}
                    selected={selected}
                    onClose={handleCalendarToggle}
                    onApplyButtonClick={(startDate, endDate) =>
                      handleApplyButtonClick(startDate, endDate)
                    }
                    startDate={startDate}
                    endDate={endDate}
                    close={true}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </>

      {expandExpense && (
        <div className="fixed inset-0  bg-gray-800 bg-opacity-80 z-40">
          <div className="flex justify-center ">
            <ExpenseModal
              chartData={dashboardStats?.expenseCategories}
              handleExpandToggle={handleExpandToggle}
              value={dashboardStats?.expenses.totalExpenseValue}
              isUptrend={dashboardStats?.transactions.percentageChange > 0}
              percentageValue={dashboardStats?.expenses.percentageChange}
              showArrow={true}
              selectedLabel={selectedLabel}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
